import { ErrorBoundary } from "./components";

import { createRouter, RouterProvider } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";
import { Toaster } from "sonner";
import "./index.css";
import "@/packages/utils";

import { LoggerProvider } from "@/packages/frontend-logger";
import { routeTree } from "./routeTree.gen";
import type { RouterContext } from "./router-context";
import {
  initSentry,
  initPerformanceMonitoring,
  ConvexClientProvider,
} from "./lib";

import "./index.css";

// Initialize Sentry before anything else
initSentry();

// Initialize performance monitoring after Sentry (for integration)
initPerformanceMonitoring();

// Create router context with services
const routerContext: RouterContext = {
  //
};

const router = createRouter({ routeTree, context: routerContext });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

ReactDOM.createRoot(rootElement).render(
  // <React.StrictMode>
  <LoggerProvider>
    <ErrorBoundary>
      <ConvexClientProvider>
        <RouterProvider router={router} />
        <Toaster
          position="top-center"
          toastOptions={{
            classNames: {
              success:
                "!bg-white !text-[#0a0a0a] !border-[#1a7a52]/25 border-l-2 !border-l-[#1a7a52] [&>[data-icon]]:text-[#1a7a52]",
            },
          }}
        />
      </ConvexClientProvider>
    </ErrorBoundary>
  </LoggerProvider>,
);

console.log("Application started");
